(() => {
  if (window.__mdaKvSignupReady) return;
  window.__mdaKvSignupReady = true;

  const ENDPOINT = 'https://a.klaviyo.com/client/subscriptions';

  function showMsg(form, text, kind) {
    const msg = form.querySelector('[data-mda-kv-msg]');
    if (!msg) return;
    msg.textContent = text;
    msg.hidden = false;
    msg.classList.remove('mda-kv-signup__msg--success', 'mda-kv-signup__msg--error');
    msg.classList.add('mda-kv-signup__msg--' + (kind === 'success' ? 'success' : 'error'));
  }

  async function submit(form) {
    const companyId = form.dataset.companyId || '';
    const listId = form.dataset.listId || '';
    const customSource = form.dataset.customSource || 'Theme signup';
    const revision = form.dataset.revision || '2024-10-15';
    const successMessage = form.dataset.successMessage || "Thanks — you're on the list.";
    const errorMessage = form.dataset.errorMessage || 'Something went wrong. Please try again.';

    if (!companyId || !listId) {
      const cfg = form.querySelector('[data-mda-kv-config-missing]');
      if (cfg) cfg.hidden = false;
      console.error('[mda-klaviyo-signup] Missing companyId or listId. Set them in theme settings.');
      return;
    }

    const emailInput = form.querySelector('input[type="email"]');
    const email = (emailInput && emailInput.value || '').trim();
    if (!email) return;

    const button = form.querySelector('button[type="submit"]');
    const wasDisabled = button ? button.disabled : false;
    if (button) button.disabled = true;

    try {
      const res = await fetch(`${ENDPOINT}?company_id=${encodeURIComponent(companyId)}`, {
        method: 'POST',
        headers: {
          'Accept': 'application/vnd.api+json',
          'Content-Type': 'application/json',
          'revision': revision
        },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: customSource,
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email
                  }
                }
              }
            },
            relationships: {
              list: { data: { type: 'list', id: listId } }
            }
          }
        })
      });

      if (res.status === 202 || res.ok) {
        showMsg(form, successMessage, 'success');
        if (emailInput) emailInput.value = '';
        form.dispatchEvent(new CustomEvent('mda:klaviyo:subscribed', { bubbles: true, detail: { email, listId } }));
      } else {
        let detail = '';
        try { detail = (await res.json()).errors?.[0]?.detail || ''; } catch (_) {}
        showMsg(form, detail || errorMessage, 'error');
      }
    } catch (err) {
      console.error('[mda-klaviyo-signup] request failed', err);
      showMsg(form, errorMessage, 'error');
    } finally {
      if (button && !wasDisabled) button.disabled = false;
    }
  }

  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[data-mda-klaviyo-signup]');
    if (!form) return;
    e.preventDefault();
    submit(form);
  });
})();
